import ArticlesPage from './ArticlesPage';

export default ArticlesPage;
